import history from 'login-utils/history';
import { SubmissionError } from 'redux-form';
import * as queryString from 'query-string';
import * as _ from 'lodash';

import * as borrowersAPI from 'login-apis/borrowersAPI';
import { SIGNUP_MESSAGES } from 'login-utils/loginErrorMessageUtils';
import { WindowWrapper } from 'login-utils/globalWrappers';
import * as userUtils from 'login-utils/userUtils';
import * as featureFlags from 'login-utils/featureFlags';
import States from 'login-constants/states';

function getErrorMessage(err) {
  const defaultError = 'There was an error submitting.';
  const errStatus = _.get(err, 'response.status', 500);

  // We want to bubble up well-formed error messages, but
  // not expose illformed ones (500s, proxy errors, etc)
  if (_.includes([400, 401, 403, 404], errStatus)) {
    return _.get(err, 'response.data', defaultError);
  }

  return defaultError;
}

export async function submitCreateAccount(values) {
  const currentLocation = history.getCurrentLocation();
  const query = queryString.parse(currentLocation.search);

  const submitValues: any = _.omit(
    values,
    'email',
    'email2',
    featureFlags.isEnabled('econsentOnlyCheckboxForLogin20190115') && ('acceptEConsent' as any),
  );
  submitValues.username = values.email;

  if (submitValues.acceptTermsOfServiceAndEConsent) {
    submitValues.acceptTerms = true;
    submitValues.modelProperties = { ...submitValues.modelProperties, econsentGiven: true };
    _.unset(submitValues, 'acceptTermsOfServiceAndEConsent');
  }

  if (_.has(query, 'loanType')) {
    // using `as any` because history.getCurrentLocation().query is of type Object
    _.set(submitValues, 'loanType', _.toUpper((query as any).loanType));
  }

  if (submitValues.loanType) {
    _.unset(submitValues, 'applicationTemplateId');
    _.unset(submitValues, 'applicationTemplateDisplayLink');

    // construction is a loan purpose type in the data model
    // so need to transform the data before sending it to the backend
    if (submitValues.loanType === 'CONSTRUCTION') {
      submitValues.loanType = 'MORTGAGE';
      submitValues.modelProperties = { ...submitValues.modelProperties, loanPurpose: 'CONSTRUCTION' };
    }
  }

  try {
    const res: any = await borrowersAPI.create(submitValues);
    const user: User = res.data;
    userUtils.setCurrentUser(user);
    if (!!user.acceptedTermsAt) {
      // On success, their terms will have been accepted; refresh the page to have
      // the backend serve the correct next stage.
      return WindowWrapper.location.reload();
    }
    history.push(States.ACCEPT_TERMS);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    if (errorMessage === SIGNUP_MESSAGES.INVALID_TEMPLATE) {
      history.push(States.CHOOSE_LOAN_TYPE);
    } else {
      throw new SubmissionError({ _error: errorMessage });
    }
  }
}
